import useMutationApi from '../useMutationApi';
import { SupplierStatus } from './useCreateSupplier';

interface UpdateSupplierData {
  name: string;
  contact_name?: string;
  email?: string;
  phone?: string;
  status: SupplierStatus;
  metadata?: {
    [key: string]: unknown;
  } | null;
}

interface UpdateSupplierResponse {
  id: string;
  name: string;
  contact_name: string | null;
  email: string | null;
  phone: string | null;
  status: string;
  metadata: {
    [key: string]: unknown;
  } | null;
}

const useUpdateSupplier = (supplierId: string, onSuccess?: () => void) => {
  return useMutationApi<UpdateSupplierData, UpdateSupplierResponse>({
    endpoint: `accounts-payable/suppliers/${supplierId}`,
    method: 'PUT',
    options: {
      onSuccess,
    },
    successMessage: 'Supplier updated successfully',
  });
};

export default useUpdateSupplier;
